<template>
  <li :class="classes" @click.stop="onSelfClick" @mouseout.stop="onSelfMouseout" v-show="visible">
    <a>
      <slot>{{ showLabel }}</slot>
    </a>
  </li>
</template>
<script>
  import Emitter from '../../mixins/emitter'
  import { PREFIX_CLASS } from '../../utils/constants'

  const PREFIX_SELECT_ITEM_CLASS = `${PREFIX_CLASS}select__item`

  export default {
    name: 'TOption',
    componentName: 'select-item',
    mixins: [ Emitter ],
    props: {
      value: {
        type: [ String, Number ],
        required: true
      },
      label: {
        type: [ String, Number ]
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        selected: false,
        index: 0, // for up and down to focus
        isFocus: false,
        visible: true,
        searchLabel: '' // the value is slot,only for search
      }
    },
    computed: {
      classes () {
        return [
          `${PREFIX_SELECT_ITEM_CLASS}`,
          {
            [`${PREFIX_SELECT_ITEM_CLASS}--disabled`]: this.disabled,
            [`${PREFIX_SELECT_ITEM_CLASS}--checked`]: this.selected,
            [`${PREFIX_SELECT_ITEM_CLASS}--focus`]: this.isFocus
          }
        ]
      },
      showLabel () {
        return (this.label) ? this.label : this.value
      }
    },
    methods: {
      onSelfClick () {
        this.select()
      },
      select () {
        if (this.disabled) {
          return false
        }
        this.dispatch('TSelect', 'on-select-selected', {
          value: this.value,
          label: (this.label === undefined) ? this.$el.children[0].innerHTML : this.label,
          instance: this
        })
      },
      onSelfMouseout () {
        this.isFocus = false
      },
      _queryChange (val) {
        const parsedQuery = val.replace(/(\^|\(|\)|\[|\]|\$|\*|\+|\.|\?|\\|\{|\}|\|)/g, '\\$1')
        let v = new RegExp(parsedQuery, 'i').test(this.searchLabel)
        if (v !== this.visible) {
          this.$parent.$emit(v ? 'item-visible' : 'item-hidden', this)
        }
        this.visible = v
      }
    },
    mounted () {
      this.searchLabel = this.$el.children[0].innerHTML.trim()
      this.$on('select-close', () => {
        this.isFocus = false
      })
      this.$on('query-change', (val) => {
        this._queryChange(val)
      })
      this.$parent.$emit('item-visible', this)
      this.dispatch('TSelect', 'item-mounted', this)
    },
    beforeDestroy () {
      if (this.visible === true) {
        this.$parent.$emit('item-hidden', this)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// option.vue?1a5cc4c5